import { useState, useEffect, useCallback, useRef } from 'react';

export const useCountdown = (initialSeconds: number) => {
  const [secondsLeft, setSecondsLeft] = useState(0);
  const startCountdown = useCallback(
    (duration = initialSeconds) => {
      setSecondsLeft(duration);
    },
    [initialSeconds],
  );
  const countDown = useRef({
    secondsLeft,
    startCountdown,
    get isRunning() {
      return this.secondsLeft > 0;
    },
  });
  countDown.current.secondsLeft = secondsLeft;
  countDown.current.startCountdown = startCountdown;
  useEffect(() => {
    if (secondsLeft <= 0) {
      return;
    }
    const intervalId = setInterval(() => {
      setSecondsLeft(prevSeconds => prevSeconds - 1);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [secondsLeft]);
  return countDown.current;
};
